export default function Logo({ compact = false }) {
  return (
    <img
      src="/logo.jpeg"
      alt="Blue City Taxi — Jodhpur's Trusted Travel Partner"
      className={compact ? "h-9 w-auto" : "h-11 sm:h-12 w-auto"}
      data-testid="brand-logo"
    />
  );
}
